const TaskIcon = ({ className, style }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3.5V6.5H5.5V3.5H2.5ZM2 2C1.44772 2 1 2.44772 1 3V7C1 7.55228 1.44772 8 2 8H6C6.55228 8 7 7.55228 7 7V3C7 2.44772 6.55228 2 6 2H2ZM6.65533 10.5947C6.94822 10.8876 6.94822 11.3624 6.65533 11.6553L4.03033 14.2803C3.73744 14.5732 3.26256 14.5732 2.96967 14.2803L1.46967 12.7803C1.17678 12.4874 1.17678 12.0126 1.46967 11.7197C1.76256 11.4268 2.23744 11.4268 2.53033 11.7197L3.5 12.6893L5.59467 10.5947C5.88756 10.3018 6.36244 10.3018 6.65533 10.5947ZM9.75 2.5C9.33579 2.5 9 2.83579 9 3.25C9 3.66421 9.33579 4 9.75 4H15.25C15.6642 4 16 3.66421 16 3.25C16 2.83579 15.6642 2.5 15.25 2.5H9.75ZM9.75 7.5C9.33579 7.5 9 7.83579 9 8.25C9 8.66421 9.33579 9 9.75 9H15.25C15.6642 9 16 8.66421 16 8.25C16 7.83579 15.6642 7.5 15.25 7.5H9.75ZM9.75 12.5C9.33579 12.5 9 12.8358 9 13.25C9 13.6642 9.33579 14 9.75 14H15.25C15.6642 14 16 13.6642 16 13.25C16 12.8358 15.6642 12.5 15.25 12.5H9.75Z"
      />
    </svg>
  )
}

export default TaskIcon
